import { render, staticRenderFns } from "./UploadFilesForIntermediary.vue?vue&type=template&id=d50763c4&"
import script from "./UploadFilesForIntermediary.vue?vue&type=script&lang=js&"
export * from "./UploadFilesForIntermediary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports